export const removeHexColorAlphaSuffix = (color: string): string => {
    return color.substring(0, 7);
};
